<template>
  <v-app class="application--is-rtl main-app" app-data="true">

    <NavBar />

    <Nuxt />

    <Footer class="footer-wrap"/>
  </v-app>
</template>

<script>
import NavBar from '@/components/NavigationMenu/NavBar'
import Footer from '@/components/Footer/Footer'

import CurrentUser from '@/components/mixins/CurrentUser'
import BrazeUserSetup from '@/components/mixins/BrazeUserSetup';


export default {
  name:'categoriesLayout',
  mixins: [CurrentUser, BrazeUserSetup],
  components: {
    NavBar,
    Footer,

  },

  data() {
    return {
      showIflogged: false
    }
  },

  beforeCreate() {
    let currentPath = this.$route.path
    switch (currentPath) {
      case '/personal/myboard':
        if (!this.isLogged) {
          this.$router.push('/enter/login')
        }
        break
    }
  }
}
</script>
